(function () {
    'use strict';

    angular
        .module("skillsApp")
        .directive("downloadReportButtons", downloadReportButtons);

    function downloadReportButtons() {
        return {
            templateUrl: '/app/directives/download-report-buttons.tpl.html',
            scope: {
                'disabled': '=',
                'onDownloadPdf': '&',
                'onDownloadExcel': '&'
            },
            controller: DownloadReportButtonsController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function DownloadReportButtonsController() {
        var vm = this;
        vm.pdfVisible = typeof (vm.onDownloadPdf()) === 'function';
        vm.excelVisible = typeof (vm.onDownloadExcel()) === 'function';
    }
})();